import { InfoIcon } from 'lucide-react';

import type { TUIElement } from '@ballerine/common';

import { createTestId } from '@/components/organisms/Renderer';
import { useStack } from '../../fields/FieldList/providers/StackProvider';
import { usePriorityFields } from '../../hooks/internal/usePriorityFields';

type IFieldPriorityReasonProps = {
  element: TUIElement;
};

export const FieldPriorityReason: React.FC<IFieldPriorityReasonProps> = ({ element }) => {
  const { stack } = useStack();
  const { priorityField } = usePriorityFields(element);

  if (!priorityField?.reason) {
    return null;
  }

  return (
    <div className="flex flex-row flex-nowrap items-start gap-2">
      <InfoIcon size={16} className="text-warning mt-1.5 shrink-0" />
      <p
        className="text-warning py-1 text-[0.8rem]"
        data-testid={`${createTestId(element, stack)}-priority-reason`}
      >
        {priorityField.reason}
      </p>
    </div>
  );
};
